"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalCloseButton = exports.ModalOverlay = exports.ModalFooter = exports.ModalBody = exports.ModalHeader = exports.ModalContent = exports.Modal = void 0;
const react_native_1 = require("react-native");
const fonts_1 = __importDefault(require("./../fonts"));
exports.Modal = {
    baseStyle: {
        //add
        ml: { base: 0, md: 160 }, //50% of drawer width to center in drawer content
    },
    defaultProps: {
        size: { base: "xl", sm: "lg" },
    },
};
exports.ModalContent = {
    baseStyle: {
        //override
        bg: "colorModalBg",
        rounded: "3xl",
        maxHeight: `${react_native_1.Dimensions.get("window").height - 40}px`,
        //add
    },
};
exports.ModalHeader = {
    baseStyle: {
        py: { base: 20, md: 30 },
        px: 40,
        borderBottomWidth: 0,
        _text: {
            //override
            fontSize: { base: "lg", md: "2xl" },
            fontWeight: null,
            color: "colorTextPrimary",
            //add
            fontFamily: fonts_1.default.bold,
            textAlign: "center",
        },
    },
};
exports.ModalBody = {
    baseStyle: {
        px: { base: 20, md: 40 },
    },
};
exports.ModalFooter = {
    baseStyle: {
        //override
        p: { base: 20, md: 30 },
        bg: "transparent",
        justifyContent: "center",
    },
};
exports.ModalOverlay = {};
exports.ModalCloseButton = {
    baseStyle: (props) => {
        return {
            bg: "colorVeryLightGray1",
            right: 12,
            top: 12,
            p: 8,
            _icon: {
                size: 12,
                color: "colorTextPrimary",
            },
        };
    },
};
